<template>
  <div class="column q-mx-auto">
    <div class="row q-mx-auto items-center">
      <q-card square bordered class="login-card q-mx-auto q-my-auto shadow-1">
        <div class="full-width justify-center flex">
          <q-img :src="retrieveAsset(require('../../assets/logo.png'))" width="50px" class="q-mx-auto"/>
        </div>
        <q-card-section>
            <div v-if="!requested" class="q-mt-sm q-mx-xl login-form">  
              <q-form autofocus @submit.prevent="request_password" @keyup.enter="request_password">
                <q-input 
                      :label="gettext('Email')"
                      v-model="email"
                      dense>
                  <template #before>
                    <q-icon :name="mdiEmail"/>
                  </template>
                </q-input>
             </q-form>
            </div>
            <p v-if="requested" class="text-caption text-center q-pt-md">{{ gettext("Your request for password was sent to your email. Check your mailbox to reset password. If nothing, maybe your email is unknown of our account.")}}</p>
            <p v-if="errorMsg" class="text-caption text-red-10 text-center q-pt-md">{{ errorMsg }}</p>
        </q-card-section>
        <q-card-actions align="center">
          <q-btn v-if="!requested" color="primary" @click.prevent="request_password" type="submit">{{ gettext("Help me")}}</q-btn>
          <q-btn v-if="requested" color="primary" @click="gotoLoginPage()">{{gettext('Login')}}</q-btn>
        </q-card-actions>
      </q-card>
    </div>
  </div>
</template>

<script>
import dj_i18n from "@/services/django_i18n";
import LoginService from "@/services/rest-auth";
import { mapStores } from 'pinia';
import { useUserTokenStore } from '@/store/usertoken';   
import utils from '@/components/utils';
import {mdiAccount, mdiLock, mdiKey, mdiLifebuoy, mdiCellphoneKey, mdiEmail} from '@quasar/extras/mdi-v7'; 

export default {
  name: "PasswordResetForm",
  mixins: [dj_i18n, utils],
  setup() {
    return { 
      mdiKey : mdiKey,
      mdiLock : mdiLock,
      mdiAccount : mdiAccount,
      mdiLifebuoy : mdiLifebuoy,
      mdiApp: mdiCellphoneKey,
      mdiEmail: mdiEmail,
      retrieveAsset : utils.retrieveAsset,
      convertJsonToMessage : utils.convertJsonToMessage
    }
  },
  data: () => ({
    email: null,
    requested: false,
    errorMsg: null
  }),
  computed: {
    ...mapStores(useUserTokenStore),
  },
  methods: {
    request_password() {
      const self = this;
      LoginService.requestReset(this.email).then(function() {
        self.requested = true;
      }).catch(function(error) {
        if(error.response) {
          self.errorMsg = error.response.data["non_field_errors"][0];
        }

      });
    },
    gotoLoginPage() {
      const self = this;
      self.$router.push("/accounts/login");
    }
  }
};
</script>
<style lang="scss">
.login-card {
  min-width:50%;
}

.login-form {
  max-width:75%;
}
.hidden {
  width:1px;
  height:1px;
}
</style>
